import { MapMarker, MapViwerWithLocationSearch, MapViwerWithSearch } from '@/components/Elements/map/MapMarker';
import React from 'react';

const NewFilterPage = () => {
  return (
    <div>
      <h2>this is filter page</h2>
      <MapViwerWithSearch />
    </div>
  );
};

export default NewFilterPage;
